module.exports = __webpack_public_path__ + "media/St 4-thermostat-correct.039ae0e4.wav";